import { PlusOutlined } from "@ant-design/icons";
import { FloatButton, Tooltip } from "antd";
import React from "react";
import { useLocation, useNavigate } from "react-router";

const FloatingShortcutButton = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isOrderPage = location.pathname === "/orders/create";

  return !isOrderPage ? (
    <Tooltip title="Create Order">
      <FloatButton
        icon={<PlusOutlined />}
        type="primary"
        onClick={() => navigate("/orders/create")}
      />
    </Tooltip>
  ) : (
    <></>
  );
};

export default FloatingShortcutButton;
